export enum TestType {
  LeakTestInboard,
  LeakTestOutboard,
  PressureTest,
  SnoopTest,
  PressureSet
}
